/**
 * Character-related constants
 *
 * These enums provide runtime-accessible values that correspond to
 * the CharacterType and CharacterStatus type unions defined in types/character.ts
 */

/**
 * Character type enum for runtime comparisons
 * Use these instead of string literals like 'pc' or 'npc'
 */
export enum CharacterTypeEnum {
  PC = 'pc',
  NPC = 'npc',
  MONSTER = 'monster',
  ANIMAL = 'animal',
}

/**
 * Character status enum for runtime comparisons
 * Use these instead of string literals like 'active' or 'dead'
 */
export enum CharacterStatusEnum {
  ACTIVE = 'active',
  RETIRED = 'retired',
  DEAD = 'dead',
}

/**
 * Special NPC type constant (used in lobby for staff NPCs like Tavian, Aldric, Kira)
 */
export const SpecialNpcType = 'special_npc' as const;
